import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BillingDoIt } from '@classes/billing-do-it';
import { BillingToDo } from '@classes/billing-to-do';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvConfigurationService } from './env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class BillingToDoService {
  environment = this.envConfigurationService.environment;

  private basePath = this.environment.apiUrl + '/billingToDo';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getBillingToDos(): Observable<Array<BillingToDo>> {
    return this.http.get<Array<BillingToDo>>(this.basePath);
  }

  doIt(doIt: BillingDoIt):Observable<any>{
    return this.http.post<any>(this.basePath + '/doit',
      doIt
    ).pipe(map(m => {
      return m
    }));
  }

}
